import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  // name: 'App'
})
export default class App extends Vue {
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/App.vm.ts